import { KeyValueListProps, KeyValuePairList } from "../KeyValueList/types";
import { KeyValuePanelProps } from "./types";

export const splitIntoNArrays = <T>(
  data: T[],
  numArrays: number,
  maxRowCount: KeyValueListProps["maxRowCount"]
) => {
  const numSplits = Math.min(numArrays, data.length);

  const newArray: T[][] = [];
  for (let index = 0; index < numSplits; index++) {
    newArray.push([]);
  }

  // we could data.forEach below since KeyValueList will hide anything beyond
  // maxRowCount anyway but exiting early may be useful for large datasets
  const numItemsToPlace = maxRowCount
    ? Math.min(maxRowCount * numSplits, data.length)
    : data.length;
  for (let index = 0; index < numItemsToPlace; index++) {
    newArray[index % numSplits].push(data[index]);
  }
  return newArray;
};

export const getNumColumnsAndVariantBasedOnWidth = (
  width: number | undefined,
  defaultNumColumns: number,
  panelVariant: KeyValueListProps["variant"]
): [KeyValueListProps["variant"], number] => {
  let variant: KeyValueListProps["variant"] = panelVariant ?? "shaded";
  let numColumns = defaultNumColumns;

  if (!width) {
    return [variant, numColumns];
  }
  if (width <= 750) {
    numColumns = 2;
  }
  if (width <= 450) {
    variant = panelVariant ?? "border";
    numColumns = 1;
  }
  return [variant, Math.min(numColumns, defaultNumColumns)];
};

export const generateIsDisplayActionRow = (
  data: KeyValuePairList,
  displayActionRowCondition: KeyValuePanelProps["displayActionRowCondition"],
  maxRowCount: KeyValueListProps["maxRowCount"],
  columnLength: number
) => {
  if (displayActionRowCondition === "always") {
    return true;
  }
  if (displayActionRowCondition === "never") {
    return false;
  }
  if (displayActionRowCondition === "onExtra") {
    if (maxRowCount) {
      if (data.length > maxRowCount * columnLength) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  return false;
};
